module.exports = __webpack_public_path__ + "media/images/slide2-4d9a6380ca48720b63330b8a3780a363a8bdfc274b46228eaa73e34977f3e6c8.jpg";